//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchMultiplyDate from '@/components/search-multiply-date';
import searchInput from '@/components/search-input';
import searchSearch from '@/components/search-search';
export default {
  name: "flow-done-list",
  components:{searchMultiplyDate,searchInput,searchSearch},
  data() {
    return {
      wrapperHeight: 0,
      page:0,
      flowList: [],
      allLoaded: false,
      searchObj:{
        firstResult: this.page,
        maxResult: 10,
        nodeType: 1
      },
    }
  },
  methods: {
    //时间搜索
    searchDate(value){
      if(value.dateGe){
        this.searchObj['createBegin'] = new Date(new Date(value.dateGe).getTime());
        this.searchObj['createEnd'] = new Date(new Date(value.dateLe).getTime()+24*60*60*1000-1);
        this.getFlowList();
      }
    },
    //删除日期
    delDate(){
      delete this.searchObj['createBegin'] ;
      delete this.searchObj['createEnd'];
      this.getFlowList()
    },
    searchRequestId(e) {
      this.searchObj['requestId']=e;
      this.getFlowList()
    },
    delRequestId(){
      delete this.searchObj['requestId'];
      this.getFlowList()
    },
    searchPerson(e) {
      this.searchObj['userId']=e.id;
      this.getFlowList()
    },
    delPerson(){
      delete this.searchObj['userId'];
      this.getFlowList()
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight =
        document.documentElement.clientHeight -
        this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    getFlowList() {
      this.page = 0;
      this.$loadingShow();
      this.$post('api/workflowRequest/getAlready', this.searchObj).then((res) => {
        if (res.content) {
          this.flowList = res.content;
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    loadTop() {
      this.page = 0;
      this.$post('api/workflowRequest/getAlready', this.searchObj).then((res) => {
        if (res.content) {
          this.flowList = res.content;
        }
        this.$refs.loadmore.onTopLoaded();
      }).catch(() => {
        this.$refs.loadmore.onTopLoaded();
      })
    },
    loadBottom() {
      this.page++;
      this.$post('api/workflowRequest/getAlready', this.searchObj).then((res) => {
        if (res.content) {
          this.flowList = this.flowList.concat(res.content);
        }
        this.$refs.loadmore.onBottomLoaded();
      }).catch(() => {
        this.$refs.loadmore.onBottomLoaded();
      })
    },
    //  跳转到流程处理页面
    dealWorkFlow(data) {
      this.$router.push(`/workflow/${data.requestId}`);
    }
  },
  mounted() {
    this.init();
    this.getFlowList();
  }
}



// WEBPACK FOOTER //
// ./src/page/flow/flow-done-list.vue